import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Combien coûte Recouvro ?",
      answer: "Recouvro coûte 1000 FCFA par propriété gérée, avec un minimum de 15 000 FCFA par mois. Si vous gérez 1 à 15 propriétés, vous payez le tarif minimum de 15 000 FCFA/mois. Au-delà de 15 propriétés, le tarif est de 1000 FCFA par propriété. Aucun frais d'installation ou frais caché."
    },
    {
      question: "Comment fonctionne votre modèle de revenus ?",
      answer: "Notre modèle est transparent : un abonnement mensuel basé sur le nombre de propriétés (1000 FCFA/propriété, minimum 15 000 FCFA/mois). En plus, nous percevons 10% sur les pénalités de retard que nous vous aidons à récupérer. Nous réussissons ensemble lorsque vous récupérez vos paiements."
    },
    {
      question: "Y a-t-il des limites sur les fonctionnalités ?",
      answer: "Non, il n'y a aucune limite. Vous avez accès à toutes les fonctionnalités complètes : nombre illimité de locataires et collaborateurs, génération de quittances, factures normalisées, tableau de bord en temps réel, notifications automatiques, et bien plus encore."
    },
    {
      question: "Est-ce que Recouvro est fiable ?",
      answer: "Oui, Recouvro est édité par DIGHITEC INNOVATIONS SARL, une entreprise légalement enregistrée au Bénin sous le N° RCCM RB/ABC/23 B 6286 et l'IFU : 3202322510966. Notre plateforme est développée selon les standards de l'industrie et bénéficie d'une maintenance régulière."
    },
    {
      question: "Est-ce que c'est un bon investissement pour mon agence ?",
      answer: "Absolument ! Pour 15 000 FCFA/mois minimum, vous automatisez toute votre gestion locative. Nos clients constatent en moyenne une réduction de 50% du temps consacré à la gestion des loyers, et économisent sur les coûts d'impression, de déplacement et de gestion manuelle. Le retour sur investissement se fait dès le premier mois."
    },
    {
      question: "Comment fonctionnent les encaissements par mobile money?",
      answer: "Les encaissements par mobile money sont inclus sans frais supplémentaires dans votre abonnement. Nous ne prélevons aucune commission sur ces transactions. Les fonds sont directement disponibles dans votre compte Recouvro et peuvent être utilisés ou retirés selon vos besoins."
    },
    {
      question: "Que pensent les autres utilisateurs de Recouvro ?",
      answer: "Nos clients témoignent régulièrement de leur satisfaction. Les agences immobilières apprécient particulièrement l'automatisation des tâches répétitives et la réduction des erreurs. Vous pouvez consulter les témoignages de nos clients actuels dans la section témoignages ci-dessus, et nous pouvons vous mettre en contact avec certains de nos clients pour discuter directement de leur expérience."
    },
    {
      question: "Pourquoi choisir Recouvro plutôt qu'une solution manuelle ?",
      answer: "Bien que la gestion manuelle soit possible, Recouvro offre une automatisation qui élimine les erreurs, réduit le temps de gestion et améliore la satisfaction des locataires. Notre solution intégrée assure la conformité légale, la génération automatique des documents et un suivi en temps réel impossible à obtenir manuellement. Vous gagnez un temps précieux tout en professionnalisant votre gestion."
    },
    {
      question: "Est-ce que mon argent est en sécurité ?",
      answer: "Oui, votre argent est totalement sécurisé. Nous utilisons des services de paiement mobile agréés et sécurisés. Chaque transaction est tracée et documentée, avec des notifications en temps réel. Les paiements sont agrégés par Recouvro, et nous assurons une transparence totale sur toutes les transactions."
    },
    {
      question: "Comment assurez-vous la sécurité des données ?",
      answer: "La sécurité est notre priorité absolue. Nous utilisons le cryptage SSL/TLS pour toutes les transmissions de données, nos serveurs sont certifiés et régulièrement audités. Les accès aux données sensibles sont protégés par authentification à deux facteurs, et nous effectuons des tests de sécurité réguliers."
    },
    {
      question: "Qu'en est-il du support technique ?",
      answer: "Notre équipe de support est disponible pendant les heures de bureau via chat, email et téléphone. Le temps de réponse moyen est de moins de 2 heures. Nous proposons également une base de connaissances complète et des tutoriels vidéo pour vous aider à tirer le meilleur parti de Recouvro."
    }
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div id="faq" className="bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Questions Fréquentes
          </h2>
          <p className="text-xl text-gray-600">
            Tout ce que vous devez savoir sur Recouvro
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden transition-all duration-200"
            >
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                onClick={() => toggleAccordion(index)}
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <span className="font-medium text-gray-900">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5 text-gray-500" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-500" />
                )}
              </button>
              {openIndex === index && (
                <div 
                  id={`faq-answer-${index}`}
                  className="px-6 py-4 bg-gray-50 border-t border-gray-200"
                >
                  <p className="text-gray-600">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-white p-8 rounded-xl shadow-sm border border-gray-200">
          <h3 className="text-xl font-semibold mb-4">Vous avez d'autres questions ?</h3>
          <p className="text-gray-600 mb-6">
            Notre équipe est disponible pour répondre à toutes vos interrogations
          </p>
          <a
            href="https://wa.me/2290197826458?text=Bonjour,%20j'ai%20une%20question%20concernant%20Recouvro"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-lg text-base font-medium text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:opacity-90 transition-all shadow-sm"
          >
            Contactez-nous
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;